angular.module('app.directives.forms.dynamic_id', [])
  .directive('dynamicId', ['$log', '$window', function ($log, $window) {
    'use strict';
    return {
      restrict: "A",
      terminal: true,
      priority: 1000,
      link: function(scope, element, attrs) {
        var id = scope.$eval(attrs.dynamicId);
        if (id) {
          element.attr('id', id);
          element.attr('name', id);
          element.removeAttr("dynamic-id");
          $compile(element)(scope);
        }
      }
     };
  }])

  .directive('dynamicFor', ['$log', '$window', function ($log, $window) {
    'use strict';
    return {
      restrict: "A",
      terminal: true,
      priority: 1000,
      link: function(scope, element, attrs) {

        var id = scope.$eval(attrs.dynamicId);
        if (id) {
          select.attr('for', id);
          element.removeAttr("dynamic-for");
          $compile(element)(scope);
        }
      }
    };
  }])
;